// Hours can legitimately be 0, which formatQuantity would turn into 1.
export const formatHours = (hours) => String(Number((Number(hours) || 0).toFixed(2)));

// "2 parts · 1.5 h", "1 part · 0 h", "No parts · 0.5 h"
export const cannedJobSummary = (job) => {
  const n = (job.parts || []).length;
  const parts = n === 0 ? 'No parts' : `${n} ${n === 1 ? 'part' : 'parts'}`;
  return `${parts} · ${formatHours(job.labor_hours)} h`;
};
